module.exports = __webpack_public_path__ + "static/media/creative.f835d7ad.svg";